
export const MOCKED_AUTOMAZIONE_CATEGORIES = [
    "ALL",
    "HERA",
    // "badge-report-magazziniere"
]

export const MOCKED_REPORTISTICA_CATEGORIES = [
    "ALL",
    "HR",
    "AUTOMEZZI",
    "SPAZZATO",
    "AMBIENTE",
]

export const MOCKED_OPERAZIONI_HR_CATEGORIES = [
    "Trend Periodo",
    "Dettaglio Operatori",
    "Dettaglio Commesse"
]

export const MOCKED_HR_GENERALE_CATEGORIES = [
    "Trend",
    "Trend KPI",
    "Trend Entrate/Uscite",
    "Dettaglio Attivi",
]

export const MOCKED_HR_DETTAGLIO_CATEGORIES = [
    "Dettaglio per GG",
    "Assegnazioni per GG"
]

export const MOCKED_OPERAZIONI_AUTOMEZZI_CATEGORIES = [
    "Generale",
    "Dettaglio",
    "Controllo Km-Ore",
    "Status Noleggi"
    // "No Mappatura"
]

export const MOCKED_OPERAZIONI_SPAZZATO_CATEGORIES = [
    "Generale",
    "Dettaglio"
]

export const MOCKED_TRANSAUTOM_CATEGORIES = [
    "Panoramica",
    "Costi Carburante",
    "Dettaglio Costi"
]

export const MOCKED_AMBIENTE_CATEGORIES = [
    "Generale",
    "Dettaglio"
]

export const MOCKED_ADMIN_CATEGORIES = [
    "Bilancino Analitico",
    "Ricavi",
    "Clienti",
    "Fornitori",
    "Data Quality"
]

export const MOCKED_HERA_CATEGORIES = [
    "REPORT COOP",
    "REPORT ODS",
    "REPORT ABITI"
]

export const MOCKED_MANUTENZIONE_CATEGORIES = [
    "Anagrafica",
    "Posizione serale",
    "Tagliandi"
]
